import { parseFrontmatter } from "@degaus/docs/frontmatter";
import { SLUG_TITLES } from "@degaus/docs/nav";

const sharedModules = import.meta.glob<string>("@docs/content/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

function slugFromPath(path: string): string {
  const match = /\/([^/]+)\.md$/.exec(path);
  return match?.[1] ?? "";
}

const sharedContent = new Map<string, string>();
for (const [path, raw] of Object.entries(sharedModules)) {
  sharedContent.set(slugFromPath(path), raw);
}

export function getPageContent(slug: string): {
  content: string;
  title: string;
  description?: string;
} | null {
  const raw = sharedContent.get(slug);
  if (!raw) return null;
  const { data, content } = parseFrontmatter(raw);
  return {
    content,
    title: data.title ?? SLUG_TITLES[slug] ?? slug,
    description: data.description,
  };
}
